'use strict';

class VoteInput extends BaseComponent {
	static get defaultState() {
		return _.assign(super.constructor.defaultState, {
			sendInputFn: RemoteData.castVote,
			choice_1: "Option 1",
			choice_2: "Option 2",
			btn_submit: "Absenden",

			sendEnabled: true
		})
	}

	constructor(element, state) {
		//init BaseComponent
		super(element, state);
		this.debug = false;

		//set template id
		this._view = $('#atoms_voteInput_VoteInput').html();

		//set template props
		this._props = {
			choice_1: this.state.choice_1,
			choice_2: this.state.choice_2,
			btn_submit: this.state.btn_submit
		};

		this.state.inputString = "";

		_.bindAll(this, 'onClickBtnSend', 'onChangeInput','sendInput');

		return this
	}

	init() {
		// this.$inInput = $('input', this.$el);
		this.$button1 = $('#choice_1', this.$el);
		this.$button2 = $('#choice_2', this.$el);
		this.$inBtnSend = $('.btn-send', this.$el);

		// this.$inInput.on('input', this.onChangeInput);
		this.$button1.on('click', this.onChangeInput);
		this.$button2.on('click', this.onChangeInput);
		this.$inBtnSend.on('click', this.onClickBtnSend);

		this.$inBtnSend.addClass('hidden');

		return this
	}

	onChangeInput(evt) {
		// this.state.inputString = this._internalState.inputString = _.trim(this.$inInput.val());
		this.state.inputString = this._internalState.inputString = _.trim($(evt.target).val());

		if(this.debug) console.log('VoteInput.onChangeInput', this.state.inputString);

		// return this;
		// send immediately
		return this.sendInput();
	}

	onClickBtnSend(evt){
		evt.preventDefault();
		if(this.debug) console.log('VoteInput.onClickBtnSend');
		return this.sendInput();
	}

	sendInput() {
		if(!this.state.sendEnabled){
			return this;
		}

		if(this.debug) console.log('sendInput', this.state.inputString);
		this.state.sendEnabled = false;
		//this.$inBtnSend.addClass('hidden');


		this.state.sendInputFn(
			// value
			this.state.inputString, 
			// on success
			res => {
				this.$el.trigger(RemoteDataEvent.CREATE, this.state.inputString);
			}, 
			// on error
			res => {
				console.error(res);
				this.$el.trigger(RemoteDataEvent.ERROR, this.state.inputString);
			}
		);

		return this
	}

	update(force = false) {
		if(!_.isEqual(this._internalState, this.state) || force) {
			this.state.sendEnabled = true;
			// this.$inInput.val(this.state.inputString);
			//then copy state
			this._internalState = _.clone(this.state);
		}

		return this;
	}
}
